<script>
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import satdosyazarfteslim from "@/models/satdosyazarfteslim";

export default {
  mixins: [apibtoast, apigeneric, satdosyazarfteslim],
  props: ["Id", "AddEdit", "satdosyaId"],
  data() {
    return {
      FormData: {},
      KurumBilgisi: [],
      ihale_komisyonu: [],
      ihaleilani: [],
      Alimturu: "",
      dipnot2: "Teklif Zarflarının İhale Komisyonuna Teslimine Dair Tutanak",
      Dosya: {},
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
    };
  },
  components: {
    Loader,
  },
  watch: {
    Id() {
      this.FormData = this.Id;
      this.FormData.Dosyaid = this.satdosyaId;
    },
  },
  created() {
    this.Get();
  },
  methods: {
    Get() {
      this.FormData = this.Id;
      this.ActionsGet({ Service: "OKurumSabit", Page: this.Page }).then((res) => {
        this.KurumBilgisi = res.Data[0];
      });

      this.ActionsGet({ Service: "SatDosya/" + this.satdosyaId, Page: this.Page }).then((res) => {
        this.Dosya = res.Data;

        this.ActionsGet({ Service: "OkeyValues/" + this.Dosya.Alimturu, Page: this.Page }).then((res) => {
          if (res) {
            if (res.Data.Value == "Mal") {
              this.Alimturu = "M";
            } else if (res.Data.Value == "Hizmet") {
              this.Alimturu = "H";
            }
          }
        });
      });

      this.ActionsFilterGet({ Service: "SatDosyaIhaleKomisyonu", Page: this.Page, Filter: "&Dosyaid=" + this.satdosyaId + "&Asc=Sira" }).then((res) => {
        this.ihale_komisyonu = res.Data;
      });

      this.ActionsFilterGet({ Service: "SatDosyaIhaleIlani", Page: this.Page, Filter: "&Dosyaid=" + this.satdosyaId }).then((res) => {
        this.ihaleilani = res.Data;
      });
    },
    Export2Word(element, filename = "Komisyon Teslim Tutanağı") {
      var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
      var postHtml = "</body></html>";
      var html = preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // Specify link url
      var url = "data:application/vnd.ms-word;charset=utf-8," + encodeURIComponent(html);

      // Specify file name
      filename = filename ? filename + ".doc" : "document.doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
  },
};
</script>
<template>
  <Loader>
    <b-modal id="komisyonateslim" size="lg" title="Teklif Zarfları Komisyona TeslimTutanağı" title-class="font-18" hide-footer>
      <div class="row mb-2">
        <div class="col-sm-4"></div>
        <div class="col-sm-8">
          <div class="text-sm-end">
            <button type="button" class="btn btn-warning btn-rounded mb-2 me-2" @click="Export2Word('exportContent')">
              <i class="mdi mdi-file-export-outline me-1"></i>
              Word'e Aktar
            </button>
          </div>
        </div>
      </div>

      <div id="exportContent">
        <div class="a4_dikey" style="margin-left:20px; ">
          <div style=" margin: 10px" class="table-responsive">
            <table>
              <tbody>
                <tr style="height: 21.5px;">
                  <td style="width: 242.5px; height: 21.5px;">İhale kayıt numarası</td>
                  <td style="width: 10px; height: 21.5px;">:</td>
                  <td style="width: 411px; height: 21.5px;">{{ ihaleilani[0].Ihalekayitnumarasi }}</td>
                </tr>
                <tr style="height: 21px;">
                  <td style="width: 242.5px; height: 21px;">İdarenin adı</td>
                  <td style="width: 10px; height: 21px;">:</td>
                  <td style="width: 411px; height: 21px;">{{ KurumBilgisi.Kurumadi }}</td>
                </tr>
                <tr style="height: 21px;">
                  <td style="width: 242.5px; height: 21px;">İşin adı</td>
                  <td style="width: 10px; height: 21px;">:</td>
                  <td style="width: 411px; height: 21px;">{{ Dosya.Dosyaadi }}</td>
                </tr>
                <tr style="height: 21px;">
                  <td style="width: 242.5px; height: 21px;">İhale tarih ve saati</td>
                  <td style="width: 10px; height: 21px;">:</td>
                  <td style="width: 411px; height: 21px;">{{ ihaleilani[0].Ihaletarihsaati | formatDateTime }}</td>
                </tr>
                <tr style="height: 21px;">
                  <td style="width: 242.5px; height: 21px;">Tutanağın d&uuml;zenlenme tarih ve saati</td>
                  <td style="width: 10px; height: 21px;">:</td>
                  <td style="width: 411px; height: 21px;">{{ Dosya.Zarfkomtestutanaktarih | formatDateTime }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p>&nbsp;</p>
          <p style="text-align: center;"><strong>TEKLİF ZARFLARININ İHALE KOMİSYONUNCA TESLİM ALINDIĞINA DAİR TUTANAK</strong></p>

          <div class="table-responsive">
            <table style="border: 1px solid; border-collapse: collapse; width:96%" border="1" class="table  table-sm table-bordered border-success mb-0">
              <tbody>
                <tr>
                  <td style="width: 105.7px; text-align: center;"><strong>SIRA NO</strong></td>
                  <td style="text-align: center;"><strong>ADI SOYADI / TİCARET &Uuml;NVANI</strong></td>
                </tr>
                <tr v-for="Data in FormData" :key="Data.Id">
                  <td style="width: 105.7px;">{{ Data.Sirano }}</td>
                  <td>{{ Data.Firmaadi }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p style="text-align: center;">&nbsp;</p>
          <p style="width:98%">İhalenin başladığı saate kadar yukarıda d&ouml;k&uuml;m&uuml; bulunan ({{ FormData.length }} ) adet&nbsp; teklif zarfı, idare marifetiyle Komisyonumuza ulaşmıştır. İhale saatine kadar saklanmış olan teklif zarfları ekte olup _ _ / _ _ / _ _ _ _ tarihinde, saat _ _:_ _&rsquo;da teslim alınmıştır.</p>

          <br />

          <div style=" margin: 10px" class="table-responsive">
            <table style="width:98%">
              <tbody>
                <tr>
                  <td colspan="6">
                    <center><strong>Teslim Alan İhale Komisyonu</strong></center>
                  </td>
                </tr>
                <tr>
                  <td colspan="6"><hr /></td>
                </tr>
                <tr>
                  <td v-for="Data in ihale_komisyonu" :key="Data.Id">
                    <table>
                      <tr>
                        <td>
                          <center>
                            {{ Data.Asilpersonel }}<br />
                            {{ Data.Gorevi }}<br />
                            {{ Data.Asilunvan }}
                          </center>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <p>Ekler</p>
          <p>EK-1 )&nbsp; &nbsp;{{ FormData.length }} Adet teklif zarfı</p>
          ------------------------------------------------
          <p style="width:98%">Bu standart form m&uuml;nferit s&ouml;zleşme aşamasında da kullanılacaktır. (M&uuml;nferit s&ouml;zleşme aşamasında ihale komisyonu &uuml;&ccedil; kişiden oluşturulacaktır.)</p>
          <p>&nbsp;</p>

          <footer>
            <p style="text-align: right;">Standart Form ― KİK005.0/{{ Alimturu }}</p>
            <p style="text-align: right;">Teklif Zarflarının İhale Komisyonuna Teslimine Dair Tutanak</p>
          </footer>
        </div>
      </div>
    </b-modal>
  </Loader>
</template>

<style>
.a4_dikey {
  width: 20.5cm;
  height: 29cm;
  position: relative;
}
.a4_dikey footer {
  position: absolute;
  bottom: 10px;
  right: 25px;
}

.yazi {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  line-height: 15px;
}
</style>
